// La session (CNX) : ses durees, en un seul endroit. Le client et le serveur lisent les memes valeurs.

/**
 * Recette : NEXT_PUBLIC_IDLE_SCALE (developpement seulement) raccourcit les seuils d'inactivite, par exemple 0.1
 * pour une fenetre a 84 s et une deconnexion a 90 s. Ignore en production.
 */
const rawScale = process.env.NODE_ENV === 'production' ? 1 : Number(process.env.NEXT_PUBLIC_IDLE_SCALE ?? 1);
const SCALE = rawScale > 0 && rawScale <= 1 ? rawScale : 1;

/** Duree de vie du jeton d'acces, en secondes (decision de Boris, 2026-11-01) */
export const ACCESS_TOKEN_MAX_AGE = 10 * 60;

/** La fenetre « Toujours la ? » apparait apres ce temps sans activite */
export const IDLE_WARNING_MS = 14 * 60_000 * SCALE;

/** Deconnexion apres ce temps sans activite */
export const IDLE_LOGOUT_MS = 15 * 60_000 * SCALE;

/** Au-dela, le serveur tient la session pour abandonnee : 15 min + la marge du signal d'activite + 1 min */
export const SERVER_IDLE_MS = 17 * 60_000 * SCALE;

/** Au plus un signal d'activite par minute ; plus souvent si la recette raccourcit les seuils */
export const ACTIVITY_PING_MS = Math.min(60_000, Math.round(SERVER_IDLE_MS / 4));

/** Les sessions d'un utilisateur, par page, dans sa fiche d'administration */
export const SESSIONS_PAGE = 10;

/**
 * Le serveur ferme les sessions sans activite. Il n'a pu l'etre qu'une fois le client capable de signaler
 * l'activite (CNX-E02) : sinon toutes les sessions se seraient fermees au bout de SERVER_IDLE_MS.
 */
export const IDLE_ENFORCED = true;
